import React from 'react';
import HeadingDescription from '../HeadingDescription';
import PointersWithHeading from '../PointersWithHeading';

function renderOvenTypes(types) {
  if (!types || !types.length) return null;
  return (
    <PointersWithHeading
      items={types.map((t) => ({ title: t.title || t.text, description: Array.isArray(t.description) ? t.description.join(' ') : t.description }))}
      numbered
    />
  );
}

export default function OvenSection({ ovenSection }) {
  if (!ovenSection) return null;

  return (
    <div className="a4-paddings quotation-page quotation-machines-details-page">
      <div className="quotation-page-inner quotation-bg-light">
        <div className="quotation-no-break" style={{ marginBottom: 16 }}>
          <h2 style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 18, fontWeight: 700, color: '#000814', margin: '0 0 4px 0' }}>
            Machines Details and Specifications
          </h2>
          <div className="quotation-yellow-divider" />
          <p style={{ fontSize: 13, color: '#333', margin: '6px 0 0 0' }}>The complete details are as below as per discussion:</p>
        </div>

        <div className="quotation-section-block">
          <HeadingDescription heading="Industrial Oven" description={ovenSection.description} level={3} />
        </div>
        <div className="quotation-section-block">
          <HeadingDescription heading="Definition for Each Oven Type" description={ovenSection.types_description} level={3} />
          {renderOvenTypes(ovenSection.types)}
        </div>
      </div>
    </div>
  );
}
